import { Box, Chip } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import { IntegrationsMapping } from "../../../stack/integrations/IntegrationsMapping";
import IntegrationImage from "../../../stack/integrations/components/IntegrationImage";

const IntegrationChip = ({
  name,
  onChipClick,
  selected = false,
  cancelSelected = true,
  displayToolName = true,
}) => {
  const colors = useColors();
  const [selectedChip, setSelectedChip] = useState(selected);
  const { displayName, logo } = IntegrationsMapping[name];

  useEffect(() => {
    setSelectedChip(selected);
  }, [selected]);
  return (
    <Chip
      label={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <IntegrationImage name={name} width={"20px"} newLogo={true} />
          {displayToolName ? displayName : null}
        </Box>
      }
      onClick={() => {
        onChipClick(name);
        cancelSelected && setSelectedChip(!selectedChip);
      }}
      style={{
        background: colors.primary_8percent,
        borderRadius: "8px",
        fontSize: "12px",
        color: colors.text_primary,
        boxShadow:
          selectedChip && `0 0 1px 1px ${colors.primary_48percent} inset`,
      }}
    />
  );
};

export default IntegrationChip;
